<template>
  <div class="main_options">
    <ul class="operate_input clearfix">
        <li v-if="options.buttons">
            <div v-for="(btns,index) in options.buttons" style="float:left;" :key="index">
                <template v-for="(page,pindex) in options.pages">
                    <template v-if="page.hasLoading">
                        <template v-if="page.time">
                            <span v-if="page.chart === btns.btnChart" :key="'time-'+pindex">
                                <el-date-picker :style="{width:page.time.width}"
                                    v-if="page.time.type === 'times'"
                                    v-model="page.time.value"
                                    :clearable="page.time.clear"
                                    :type="page.time.date || 'daterange'"
                                    :value-format="page.time.format || 'yyyy-MM-dd'"
                                    :picker-options="page.time.disabledDate"
                                    :default-time="page.time.defaultTime"
                                    :placeholder="page.time.placeholder"
                                    :range-separator="page.time.separator||'至'"
                                    :start-placeholder="page.time.startPlaceholder||'开始时间'"
                                    :end-placeholder="page.time.endPlaceholder||'结束时间'"
                                    size="mini">
                                </el-date-picker>
                            </span>
                        </template>
                        <template>
                            <el-button
                                size="mini" 
                                :type="(page.type || 'primary')"
                                :loading="page.loading"
                                v-if="page.chart === btns.btnChart" 
                                :key="pindex"
                                @click="page.event(operationData)">
                                <span>{{btns.name||page.name}}</span>
                            </el-button>
                        </template>
                    </template>
                    <template v-else>
                        <!-- <div class="my_button" style="margin-right:10px" 
                        v-show="page.show || true"
                        v-if="page.chart === btns.btnChart" 
                        :key="pindex"
                        :style="page.name=='返回'?{backgroundColor:'#ecf5ff',color:'#458FD9',borderColor:'#458FD9'}:(page.style?page.style:{})" 
                        @click="page.event(operationData)" >
                            <span>{{btns.name||page.name}}</span>
                        </div> -->
                        <el-button
                            size="mini" 
                            :type="(page.type || (page.name === '导出' ? 'success' : 'primary'))"
                            v-show="page.show || true"
                            v-if="page.chart === btns.btnChart" 
                            :key="pindex"
                            style="margin-right:10px" 
                            :style="page.name=='返回'?{backgroundColor:'#ecf5ff',color:'#458FD9',borderColor:'#458FD9'}:(page.style?page.style:{})" 
                            @click="page.event(operationData)" >
                            <span>{{btns.name||page.name}}</span>
                        </el-button>
                    </template>
                </template>
            </div>
        </li>
        <li v-if="options.funcs || options.others">
            <ul class="options_funcs clearfix">
                <template v-for="(btns,i) in options.buttons">
                    <li v-if="options.buttons" :key="i">
                        <div class="clearfix" style="dispaly:inline-block;" >
                            <template v-for="(func,findex) in options.funcs">
                                <template v-if="func.chart === btns.btnChart">
                                    <template v-if="func.icon === 'export'">
                                        <!-- <div class="my_button export_btn" v-if="func.icon === 'export'" style="margin: 0 5px;">{{func.name}}</div> -->
                                        <el-button
                                            :key="'back-'+findex"
                                            size="mini"
                                            type="success"
                                            style="margin:0 10px"
                                            @mouseenter="mouseIsIn(true,findex)" 
                                            @mouseleave="mouseIsIn(true)"
                                            @click="func.event(operationData)">{{func.name}}</el-button>
                                    </template>
                                    <template v-else>
                                        <div
                                            :key="findex"
                                            @mouseenter="mouseIsIn(true,findex)" 
                                            @mouseleave="mouseIsIn(true)"
                                            @click="func.event(operationData)" 
                                            style="float:left;">
                                            <div class="options_icon">
                                                <i v-if="func.icon === 'del'" :style="{background:'url('+delIcon+')'}"></i>
                                                <i v-if="func.icon === 'edit'" :style="{background:'url('+editIcon+')'}"></i>
                                                <i v-if="func.icon === 'export'" :style="{background:'url('+exportIcon+')'}"></i>
                                                <i v-if="func.icon === 'printing'" :style="{background:'url('+printIcon+')'}"></i>
                                                <span class="options_name" v-show="mouseIn === findex">{{func.name}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                            
                        </div>
                    </li>
                </template>
                
                <li v-if="options.others" class="other_icon">
                    <div style="width:100%;height:100%" @click.stop="openOptions">
                        <i :style="{background:'url('+moreIcon+')'}"></i>
                    </div>
                    <template v-for="(btns,index) in options.buttons">
                        <ul class="other_options" v-show="isOpen" v-if="options.buttons" :key="index">
                            <template v-for="(other,oindex) in options.others">
                                <li v-if="other.chart === btns.btnChart" 
                                    :key="oindex"
                                    @click="other.event(operationData)">{{other.name}}</li>
                            </template>
                        </ul>
                    </template>
                </li>
            </ul>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
    name:'vOptions',
    props:{
        options:{
            type:Object,
            default:function(){
                return {}
            }
        },
        operationData:{
            type:Array,
            default:function(){
                return []
            }
        }
    },
    data(){
        return {
            exportIcon: require('../assets/export.png'),
            delIcon: require('../assets/clear.png'),
            editIcon: require('../assets/edit.png'),
            printIcon: require('../assets/printing.png'),
            moreIcon: require('../assets/more.png'),
            isOpen: false,
            mouseIn: -1,
        }
    },
    mounted() {
    },
    computed:{
    },
    methods:{
        openOptions(){
            this.isOpen = !this.isOpen;
        },
        mouseIsIn(boo,index){
            if(boo){
                this.mouseIn = index
            }else{
                this.mouseIn = -1
            }
        },
    }
}
</script>

<style scoped>
.main_options{
    height: 39px;
    /* border-top: 1px solid #E7E7E7;
    border-left: 1px solid #E7E7E7;
    border-right: 1px solid #E7E7E7; */
    padding: 0 10px;
}
.operate_input{
    padding-top: 10px;
}
.operate_input>li{
    height: 28px;
    line-height: 28px;
    float: left;
}
.options_funcs{
    border-radius: 2px;
}
.options_funcs>li{
    height: 28px;
    text-align: center;
    float: left;
    cursor: pointer;
    position: relative;
    /* background-color:#F6F6F6; */
}
.options_icon{
    position: relative;
    height: 27px;
    width: 40px; 
    border: 1px solid #E7E7E7;
    margin-left: -1px;
    background-color:#F6F6F6;
}
.options_icon:nth-child(1){
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}
.options_icon:nth-last-child(1){
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
}
.options_icon>i{
    display: inline-block;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 6px;
    left: 13px;
}
.options_name{
    min-width: 40px;
    height: 26px;
    position: absolute;
    top: -30px;
    left: 0;
    background-color: #2E2E2E;
    border-radius: 2px;
    color: #fff;
    overflow: hidden;
    white-space:nowrap;
    z-index: 999;
    transition: .3s;
}
.other_options{
    min-width: 81px;
    background-color: #fff;
    z-index: 999;
    position: absolute;
    right: -1px;
    top: 26px;
    border: 1px solid #E8E8E8;
}
.other_options>li{
    white-space:nowrap;
    margin: 5px 0;
}
.other_options>li:hover{
    background-color: #f4f4f4;
}

.options_funcs .other_icon{
    position: relative;
    height: 26px;
    width: 40px; 
    margin-left: -1px;
    border:1px solid #E7E7E7;
    border-top-right-radius:2px;
    border-bottom-right-radius:2px;
}
.options_funcs .other_icon i{
    display: inline-block;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 6px;
    left: 13px;
}
.export_btn{
    background-color: #67c23a;
}
</style>


// WEBPACK FOOTER //
// src/components/options.vue